import {useLocalStorage} from '~ui/hooks';

export function useEditorDraft(slug?: string) {
    const draftKey = `${slug}-draft`;
    const [draft, setDraft, removeDraft] = useLocalStorage<undefined | string>(draftKey);

    return {draft, setDraft, removeDraft};
}
